// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application";
import datepicker_controller from "./datepicker_controller";
import DropzoneController from "./dropzone_controller";
import EnterSubmitController from "./enter_submit_controller";
import ResetController from "./reset_controller";
import ConversationController from "./conversation_controller";
import PropertySidebarController from "./property_sidebar_controller";
import TextareaAutogrow from "stimulus-textarea-autogrow";
import Clipboard from "@stimulus-components/clipboard";

import "./railsui";
import HelloController from "./hello_controller";
import choices_controller from "./choices_controller";
import ai_extension from "./trix/ai_extension";
import intl_tel_controller from "./intl_tel_controller";
import select_city_controller from "./select_city_controller";
import reveal_phone_controller from "./reveal_phone_controller";

application.register("hello", HelloController);
application.register("datepicker", datepicker_controller);
application.register("dropzone", DropzoneController);
application.register("choices", choices_controller);
application.register("enter-submit", EnterSubmitController);
application.register("reset", ResetController);
application.register("conversation", ConversationController);
application.register("property-sidebar", PropertySidebarController);
application.register("trix--ai-extension", ai_extension);
application.register("intl-tel", intl_tel_controller);
application.register("select-city", select_city_controller);
application.register("autogrow", TextareaAutogrow);
application.register("reveal-phone", reveal_phone_controller);
application.register("clipboard", Clipboard);
